import React, { FormEvent, useState } from "react";
import { RiErrorWarningLine } from "react-icons/ri";
import { InitialValuesProps, Product } from "../models/ticket";
import { Input } from "./Input";

interface ContainerAddProductProps {
  newProduct: Product;
  setNewProduct: (product: Product) => void;
  handleProducts: (data: Product) => void;
  handleChange: any;
  showEdit: boolean;
  setShowEdit: (value: boolean) => void;
  setShowAdd: (value: boolean) => void;
  setValues: any;
  values: InitialValuesProps;
}

export function ContainerAddProduct({
  newProduct,
  setNewProduct,
  handleChange,
  handleProducts,
  setShowEdit,
  showEdit,
  setShowAdd,
  values,
  setValues,
}: ContainerAddProductProps) {
  const [errors, setErrors] = useState({ quantity: "", price: "", name: "" });

  const maskReais = (value: string) => {
    return (Number(value.replace(/\D/g, "")) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  function handleChangeCurrency(e: FormEvent<HTMLInputElement>) {
    let value = e.currentTarget.value;

    value = maskReais(value);

    e.currentTarget.value = value;

    setNewProduct({
      ...newProduct,
      price: Number(
        value.replace(/\D\$/g, "").replace(/\./g, "").replace(/,/g, ".")
      ),
    });
  }

  function addNewProduct() {
    if (newProduct.name === "") {
      setErrors({ ...errors, name: "Nome do produto é obrigatório" });
      return;
    } else {
      setErrors({ ...errors, name: "" });
    }

    if (newProduct.quantity === 0) {
      setErrors({ ...errors, quantity: "Quantidade deve ser maior que zero" });
      return;
    } else {
      setErrors({ ...errors, quantity: "" });
    }

    if (newProduct.price <= 0) {
      setErrors({ ...errors, price: "Preço deve ser maior que zero" });
      return;
    } else {
      setErrors({ ...errors, price: "" });
    }

    setShowEdit(false);
    setShowAdd(false);

    if (!showEdit) {
      handleProducts({
        ...newProduct,
        id: Date.now(),
      });
    } else {
      setValues({
        ...values,
        productList: values.productList.map((product) => {
          if (product.id === newProduct.id) {
            return {
              ...product,
              ...newProduct,
            };
          }
          return product;
        }),
      });
    }

    setNewProduct({
      name: "",
      price: 0,
      quantity: 0,
      id: 0,
    });
  }

  return (
    <div className="containerAddNewProduct">
      <div className="d-flex align-items-end row mb-3">
        <div className="col-7 col-md-8 ">
          <Input
            label="Nome do produto"
            error={errors.name}
            value={newProduct.name}
            onChange={(e) =>
              setNewProduct({ ...newProduct, name: e.currentTarget.value })
            }
          />
        </div>

        <div className="col-5 col-md-4 ">
          <div
            className={`containerQuantityButtons ${
              errors.quantity ? "error" : ""
            }`}
          >
            <button
              type="button"
              onClick={() =>
                setNewProduct({
                  ...newProduct,
                  quantity:
                    newProduct.quantity !== 0 ? newProduct.quantity - 1 : 0,
                })
              }
            >
              -
            </button>

            <span>{newProduct.quantity}</span>

            <button
              type="button"
              onClick={() =>
                setNewProduct({
                  ...newProduct,
                  quantity: newProduct.quantity + 1,
                })
              }
            >
              +
            </button>
          </div>
          {errors.quantity && (
            <div className="errorMessage">
              <RiErrorWarningLine size={24} />
              <span>{errors.quantity}</span>
            </div>
          )}
        </div>
      </div>

      <div className="d-flex align-items-end row">
        <div className="col-12 col-md-8 mb-2">
          <Input
            label="Preço unitário"
            defaultValue={newProduct.price}
            inputMode="numeric"
            onChange={(e) => handleChangeCurrency(e)}
            error={errors.price}
          />
        </div>
        <div className="col-12 col-md-4 mb-2">
          <button type="button" className="button" onClick={addNewProduct}>
            {showEdit ? "Editar" : "Adicionar"}
          </button>
        </div>
      </div>
    </div>
  );
}
